import { render, staticRenderFns } from "./PageNewStaff.vue?vue&type=template&id=2b142a18"
import script from "./PageNewStaff.vue?vue&type=script&lang=js"
export * from "./PageNewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports